import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  "aria-hidden": "true",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2M7 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }, null, -1)
  ])))
}
export default { render: render }